<template>
  <div>
    <Form :options="formOptions"></Form>
  </div>
</template>
<script>
import Form from '../../../../src/components/form/Form.vue'
import axios from '@/components/axios'
import moment from 'moment'
const baseApi = process.env.VUE_APP_APIENDPOINT
export default {
  data () {
    return {
      formOptions: {
        formTitle: `${
          this.$route.query.id ? 'Edit Purchas Order' : 'Add Purchase Order'
        }`,
        submitRouterPath: '/crm/purchaseorder',
        usersDropdown: true,
        method: 'post',
        action: 'add',
        url: `${baseApi}/purchaseorder`,
        inputFields: [
          {
            name: 'branch',
            value: 1,
            type: 'hidden'
          },
          {
            name: 'company',
            value: 1,
            type: 'hidden'
          },
          {
            name: 'active',
            value: 1,
            type: 'hidden'
          },
          {
            label: 'Purchase Quotation No',
            name: 'materialinwardno',
            value: '',
            type: 'dropdown',
            class: 'col-md-6',
            // url: "modules",
            required: true,
            options: []
          },
          {
            label: 'Purchase Order Date ',
            name: 'purchaseorderdate',
            value: '',
            type: 'date',
            class: 'col-md-6',
            // url: "modules",
            required: true
          },
          {
            label: 'Purchase Order By',
            name: 'purchaseorderby',
            value: '',
            type: 'dropdown',
            class: 'col-md-6',
            // url: "modules",
            required: true,
            options: []
          },
          {
            label: 'Company Name',
            name: 'companyname',
            value: '',
            type: 'dropdown',
            class: 'col-md-6',
            // url: "modules",
            required: true,
            options: []
          },
          {
            label: 'Payment Term(in Days)',
            name: 'Paymentterm',
            value: '',
            type: 'text',
            class: 'col-md-6',
            placeholder: 'Enter Payment Terms',
            required: true
          },
          {
            label: 'Supplier',
            name: 'supplier',
            value: '',
            type: 'text',
            class: 'col-md-6',
            placeholder: 'Enter Supplier',
            required: true,
            options: []
          },
          {
            label: 'Project Name',
            name: 'projectname',
            value: '',
            type: 'dropdown',
            class: 'col-md-6',
            // url: "modules",
            required: true,
            options: []
          },
          {
            label: 'Delivery Date',
            name: 'deliverydate',
            value: '',
            type: 'text',
            class: 'col-md-6',
            placeholder: 'Enter Delivery Date',
            required: true
          },
          {
            label: 'Supplier',
            name: 'supplier',
            value: '',
            type: 'number',
            class: 'col-md-6',
            placeholder: 'Enter Supplier',
            required: true
          },
          {
            label: 'Supplier Mobile',
            name: 'suppliermobile',
            value: '',
            type: 'number',
            class: 'col-md-6',
            placeholder: 'Enter Supplier Mobile',
            required: true
          },
          {
            label: 'Supplier Email',
            name: 'supplieremail',
            value: '',
            type: 'text',
            class: 'col-md-6',
            placeholder: 'Enter Supplier Email',
            required: true
          },
          {
            label: 'Supplier Address',
            name: 'supplieraddress',
            value: '',
            type: 'text',
            class: 'col-md-6',
            placeholder: 'Enter Supplier Address',
            required: true
          },
          {
            label: 'Remarks',
            name: 'remarks',
            value: '',
            type: 'text',
            class: 'col-md-6',
            placeholder: 'Enter Remarks',
            required: true
          },
          {
            label: 'Barter %',
            name: 'barter',
            value: '',
            type: 'number',
            class: 'col-md-6',
            placeholder: 'Enter Auth Person',
            required: true
          },
          {
            label: 'Delivery to Name',
            name: 'deliverytoname',
            value: '',
            type: 'text',
            class: 'col-md-6',
            placeholder: 'Enter Delivery to Name',
            required: true
          },
          {
            label: 'Delivery to Adderess',
            name: 'deliverytoaddress',
            value: '',
            type: 'text',
            class: 'col-md-6',
            placeholder: 'Enter Delivery to Address',
            required: true
          },
          {
            label: 'Delivery to Mobile',
            name: 'deliverytomobile',
            value: '',
            type: 'text',
            class: 'col-md-6',
            placeholder: 'Enter Delivery to Mobile',
            required: true
          },
          {
            label: 'Shipping Method',
            name: 'shippingmethod',
            value: '',
            type: 'text',
            class: 'col-md-6',
            placeholder: 'Enter Shipping Method',
            required: true
          },
          {
            title: 'Product Info',
            type: 'formrepeater',
            inputFields: [
              {
                label: 'Category',
                name: 'Category',
                value: '',
                type: 'dropdown',
                class: 'col-md-2',
                required: true
                // url: "",
              },
              {
                label: 'Product Name',
                name: 'productname',
                value: '',
                type: 'text',
                placeholder: 'Enter Product Name',
                class: 'col-md-2',
                required: true
              },
              {
                label: 'Qty',
                name: 'qty',
                value: '',
                type: 'number',
                placeholder: 'Enter Qty',
                class: 'col-md-2',
                required: true
              },
              {
                label: 'Unit',
                name: 'unit',
                value: '',
                type: 'dropdown',
                class: 'col-md-2',
                required: true
                // url: "",
              },
              {
                label: 'Rate',
                name: 'rate',
                value: '',
                type: 'number',
                placeholder: 'Enter Rate',
                class: 'col-md-1',
                required: true
              },
              {
                label: 'Amount',
                name: 'amount',
                value: '',
                type: 'number',
                placeholder: 'Enter Amount',
                class: 'col-md-1',
                required: true
              }
            ]
          },
          {
            label: 'Cash Amount',
            name: 'cashamount',
            value: '',
            type: 'number',
            class: 'col-md-6',
            placeholder: 'Enter Cash Amount',
            disable: true
          },
          {
            label: 'Barter Amount',
            name: 'barteramount',
            value: '',
            type: 'number',
            class: 'col-md-6',
            placeholder: 'Enter Barter Amount',
            disable: true
          },
          {
            label: 'Total',
            name: 'total',
            value: '',
            type: 'number',
            class: 'col-md-6',
            placeholder: 'Enter Total',
            disable: true
          }
        ]
      }
    }
  },
  components: {
    Form
  },
  beforeMount () {
    const accessToken = localStorage.getItem('accessToken')
    const baseApi = process.env.VUE_APP_APIENDPOINT
    this.formOptions.inputFields.map(async (item) => {
      if (item.type == 'dropdown' && item.url) {
        const requestOptionsUsers = {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${accessToken}`
          },
          url: `${baseApi}/${item.url}`
        }

        await axios(requestOptionsUsers)
          .then((response) => {
            response.data.data.data
              ? (item.options = response.data.data.data)
              : (item.options = response.data.data)
          })
          .catch((error) => console.log(error, 'error'))
      }
    })
  },
  mounted () {}
}
</script>
